// removed by extract-text-webpack-plugin
module.exports = {"applicationMenuPanelGroup":"_2z_7FSdNmVIA7NOC2AK-8f"};


//////////////////
// WEBPACK FOOTER
// ./src/DomainApplicationView/DomainApplicationMenu.css
// module id = 182
// module chunks = 0